export default {
  
  setBoms(state, data) {
    state.boms = data;
  },
  setBom(state, data) {
    state.bom = data;
  },

  setBomCode(state, data) {
    state.bomCode = data;
  },

  setBomByCode(state, data) {
    state.bomByCode = data;
  },

  setBomCommodities(state, data) {
    state.bomCommodities = data;
  },

  setBomNavigation(state, data) {
    state.bomNavigation = data;
  },

  setSetting(state, data) {
    state.setting = data;
  },

  setProduction(state, data) {
    state.production = data;
  },
  setProductionItem(state, data) {
    state.productionItem = data;
  },
  setProductionNavigation(state, data) {
    state.productionNavigation = data;
  },
  setProductionCode(state, data) {
    state.productionCode = data;
  },

  setProductionDetailsReport(state, data) {
    state.productionDetailsReport = data;
  },

  setProductionCalculate(state, data) {
    state.productionCalculate = data;
  },

  setProductionCostsReport(state, data) {
    state.productionCostsReport = data;
  },

  setProducedProductsReport(state, data) {
    state.producedProductsReport = data;
  },

  setConsumedRawMaterials(state, data) {
    state.consumedRawMaterials = data;
  },
};
